var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.label,"placeholder":"dd/mm/yyyy","hint":"dia / mes / año","error":!_vm.esFechaValida,"prepend-icon":"mdi-calendar","disabled":_vm.disabled},on:{"change":_vm.validarYFormatear},model:{value:(_vm.fechaEdit),callback:function ($$v) {_vm.fechaEdit=$$v},expression:"fechaEdit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }